<h2 class="mb-1h mb-lg-1hq fs-42 text-info">
  Faça uma Cotação
</h2>
<form [formGroup]="formGroup"
      class="needs-validation"
      novalidate>
  <fieldset class="pb-lg-18px mb-lg-18px">
    <div class="row">
      <div class="col-lg-6">
        <div class="mb-1 mb-lg-10px">
          <label for="name"
                 class="sr-only">
            Nome
          </label>
          <input type="text"
                 class="form-control"
                 formControlName="nome"
                 placeholder="Nome"
                 [ngClass]="{'is-invalid': validaCampo(formGroup,'nome')}">
          <ng-container *ngIf="getCampo(formGroup,'nome').errors?.required">
            <span class="invalid-feedback">
              Por favor, preencha o campo Nome
            </span>
          </ng-container>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="mb-1 mb-lg-10px">
          <label for="e-mail"
                 class="sr-only">
            E-mail
          </label>
          <input type="email"
                 class="form-control"
                 formControlName="email"
                 placeholder="E-mail"
                 [ngClass]="{'is-invalid': validaCampo(formGroup,'email')}">
          <ng-container *ngIf="getCampo(formGroup,'email').errors?.required">
            <span class="invalid-feedback">
              Por favor, preencha o campo E-mail
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="mb-1 mb-lg-10px">
          <label for="tel"
                 class="sr-only">
            Telefone
          </label>
          <input type="tel"
                 class="form-control"
                 formControlName="telefone"
                 mask="(00) 0000-0000||(00) 00000-0000"
                 placeholder="Telefone"
                 [ngClass]="{'is-invalid': validaCampo(formGroup,'telefone')}">
          <ng-container *ngIf="getCampo(formGroup,'telefone').errors?.required">
            <span class="invalid-feedback">
              Por favor, preencha o campo Telefone
            </span>
          </ng-container>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="mb-1 mb-lg-10px">
          <label for="cep"
                 class="sr-only">
            CEP
          </label>
          <input type="tel"
                 class="form-control"
                 formControlName="cep"
                 mask="00000-000"
                 placeholder="CEP"
                 [ngClass]="{'is-invalid': validaCampo(formGroup,'cep')}">
          <ng-container *ngIf="getCampo(formGroup,'cep').errors?.required">
            <span class="invalid-feedback">
              Por favor, preencha o campo CEP
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="mb-1 mb-lg-0">
      <select class="form-control form-select"
              formControlName="concessionaria"
              [ngClass]="{'is-invalid': validaCampo(formGroup,'concessionaria')}"
              (change)="setConcessionaria($event)">
        <option value="">Concessionária</option>
        <ng-container *ngFor="let concessionaria of concessionarias">
          <option [value]="concessionaria.id">{{concessionaria.nomeFantasia}}</option>
        </ng-container>
      </select>
      <ng-container *ngIf="getCampo(formGroup,'concessionaria').errors?.required">
        <span class="invalid-feedback">
          Por favor, preencha o campo Concessionária
        </span>
      </ng-container>
    </div>
  </fieldset>
  <fieldset class="pb-lg-0 mb-lg-18px">
    <h2 class="text-white mb-lg-18px">
      Selecione seu produto
    </h2>
    <div class="mb-1 mb-lg-18px">
      <div class="row gx-lg-0">
        <ng-container *ngFor="let product of products">
          <div class="col-lg-auto">
            <div class="mb-lg-0 pe-lg-25px">
              <input formControlName="produto"
                     type="radio"
                     name="produto"
                     class="form-check-input"
                     [id]="product.id"
                     [value]="product.value"
                     [ngClass]="{'is-invalid': validaCampo(formGroup, 'produto')}">
              <label class="ps-0h text-white"
                     [for]="product.id">
                {{ product.label }}
              </label>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </fieldset>
  <div class="mb-1 mb-lg-18px">
    <app-terms-of-acceptance [formGroup]="formGroup" idOfField="politica-privacidade" additionalClassInDescriptionOfTerms="text-secondary" [politicaPrivacidade]="politicaPrivacidade">
      <input type="checkbox" class="form-check-input" id="politica-privacidade"
             formControlName="politicaPrivacidade"
             [ngClass]="{'is-invalid': validaCampo(formGroup,'politicaPrivacidade')}">
    </app-terms-of-acceptance>
  </div>
  <div class="row justify-content-end mb-lg-18px">
    <div class="col-auto">
      <button (click)="enviar();"
              type="button"
              class="btn btn-block btn-info"
              [disabled]="isSubmitting">
        <span *ngIf="isSubmitting"
              class="spinner-border spinner-border-sm me-1"
              role="status" aria-hidden="true"></span>
        {{ isSubmitting ? 'Enviando...' : 'Enviar' }}
      </button>
    </div>
  </div>
</form>
